import * as React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import Modal from "../Modal";

export default function BulkDeleteConfirmation(props) {
  const { open, deleteLineClick, handleClose, numLines } = props;

  const onClose = (refresh = false) => {
    handleClose(refresh);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      width={470}
      icon={NotificationImportantIcon}
      iconColor="draft"
      iconMarginLeft={-40}
      title={
        <b>
          Delete {numLines} {numLines === 1 ? "line" : "lines"}
        </b>
      }
      text={
        <>
          Do you want to delete the selected{" "}
          {numLines === 1 ? "" : `${numLines} `}
          {numLines === 1 ? "line" : "lines"}? Don't worry, you can always
          create more lines at any time.
        </>
      }
    >
      <DialogActions style={{ display: "flex", justifyContent: "flex-start" }}>
        <Button onClick={deleteLineClick} color="primary">
          Delete
        </Button>
        <Button color="primary" autoFocus onClick={() => onClose()}>
          Cancel
        </Button>
      </DialogActions>
    </Modal>
  );
}
